"use client"
import { Zap, BookOpen, Calculator } from "lucide-react"

const SubjectFilter = ({ activeFilter, setActiveFilter }) => {
  const filters = [
    { id: "all", name: "All Subjects", icon: null },
    { id: "physics", name: "Physics", icon: <Zap className="w-4 h-4" /> },
    { id: "chemistry", name: "Chemistry", icon: <BookOpen className="w-4 h-4" /> },
    { id: "math", name: "Math", icon: <Calculator className="w-4 h-4" /> },
  ]

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-8">
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => setActiveFilter(filter.id)}
          className={`flex items-center space-x-1 px-4 py-2 rounded-md transition-colors ${
            activeFilter === filter.id ? "bg-gray-800 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          {filter.icon && filter.icon}
          <span>{filter.name}</span>
        </button>
      ))}
    </div>
  )
}

export default SubjectFilter
